module.exports = __webpack_public_path__ + "img/co_wrapbg10.261ba57a.png";